import { TextField } from '@mui/material';
import Button from '@shared/components/Buttons/Button';
import { useState } from 'react';
import ItemList from './ItemList';

interface ArrayFieldEditorProps {
  label: string;
  items: string[];
  isViewMode: boolean;
  onAdd: (value: string) => void;
  onRemove: (index: number) => void;
  itemType?: 'chip' | 'list';
  placeholder?: string;
  helpText?: string;
  multiline?: boolean;
  testIdPrefix?: string;
}

function ArrayFieldEditor({
  label,
  items,
  isViewMode,
  onAdd,
  onRemove,
  itemType = 'list',
  placeholder,
  helpText,
  multiline = false,
  testIdPrefix,
}: ArrayFieldEditorProps) {
  const [inputValue, setInputValue] = useState('');

  const handleAdd = () => {
    if (inputValue.trim()) {
      onAdd(inputValue.trim());
      setInputValue('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !multiline) {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <div className="mb-24">
      <div className="offering-field__label">{label}</div>
      {!isViewMode && helpText && <div className="offering-field__caption">{helpText}</div>}
      <ItemList items={items} itemType={itemType} isViewMode={isViewMode} onRemove={onRemove} />
      {!isViewMode && (
        <div className="d-flex mt-16" style={{ gap: '8px', alignItems: 'flex-start' }}>
          <TextField
            data-testid={testIdPrefix ? `add-${testIdPrefix}-input` : undefined}
            size="small"
            label={placeholder || `Add ${label.toLowerCase()}`}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            multiline={multiline}
            rows={multiline ? 2 : 1}
            style={{ flex: 1 }}
          />
          <Button
            data-testid={testIdPrefix ? `add-${testIdPrefix}-button` : undefined}
            size="small"
            onClick={handleAdd}
            whiteTheme
          >
            Add
          </Button>
        </div>
      )}
    </div>
  );
}

export default ArrayFieldEditor;
